/* DSL Web Vitals — minimale LCP / INP / CLS reporter via sendBeacon */
(function(){
  if (!("PerformanceObserver" in window)) return;
  var data = {lcp:null, cls:0, inp:null, navigation: location.pathname};
  function send(){
    try {
      var payload = JSON.stringify({type: "vitals", data: data, ts: Date.now(), ua: navigator.userAgent.slice(0,200)});
      if (window.DSL_AB) window.DSL_AB.track("vitals", data);
      // Endpoint placeholder: adjust to your collector
      if (navigator.sendBeacon) navigator.sendBeacon("/apps/dsl-collect", payload);
    } catch(e){}
  }
  // LCP
  try {
    new PerformanceObserver(function(list){
      var entries = list.getEntries();
      var last = entries[entries.length - 1];
      data.lcp = Math.round(last.renderTime || last.loadTime);
    }).observe({type: "largest-contentful-paint", buffered: true});
  } catch(e){}
  // CLS
  try {
    new PerformanceObserver(function(list){
      list.getEntries().forEach(function(entry){
        if (!entry.hadRecentInput) data.cls += entry.value;
      });
    }).observe({type: "layout-shift", buffered: true});
  } catch(e){}
  // INP: track event timings
  try {
    new PerformanceObserver(function(list){
      list.getEntries().forEach(function(entry){
        var dur = entry.duration | 0;
        if (data.inp === null || dur > data.inp) data.inp = dur;
      });
    }).observe({type: "event", buffered: true, durationThreshold: 16});
  } catch(e){}
  addEventListener("visibilitychange", function(){ if (document.visibilityState === "hidden") send(); });
  addEventListener("pagehide", send, {once: true});
})();